import { Component } from '@ecs/Component';

export type EffectType = 
  | 'explosion' 
  | 'muzzleFlash' 
  | 'chargeEffect' 
  | 'shieldImpact'
  | 'torpedoLaunch';

export class VisualEffect implements Component {
  readonly type = 'VisualEffect';
  
  constructor(
    public effectType: EffectType,
    public duration: number,
    public startTime: number = Date.now(),
    public params: Record<string, any> = {}
  ) {}
}